<template>
    <div class="diagram" :id=id>
    </div>
</template>

<script>
    import HeatmapSpec from '../vega-spec/heatmap.v.json'
    import embed from 'vega-embed'

    export default {
        name: "DemographicsHeatmap",
        props: ["data", "id", "properties", "title"],
        data() {
            return {
                spec: {}
            }
        },
        watch: {
            spec(v) {
                if (v) this.draw()
            },
            data(v) {
                this.load(v)
                this.draw()
            }
        },
        mounted: function () {
            this.spec = JSON.parse(JSON.stringify(HeatmapSpec)) // Clone
            this.load(this.data)
        },
        methods: {
            async draw() {
                await embed('#' + this.id, this.spec, {actions: false})
                    .catch(err => console.error(err))

            },
            load(v) {
                if (!v) return;
                this.spec["data"][0]["values"] = Object.entries(this.properties)
                    .map(([name, extent]) => ({
                        "category": name,
                        "value": v[name] ? (v[name] - extent[0])/(extent[1] - extent[0]) : null,
                        "label": v[name]
                    }))
                this.spec["title"]["text"] = this.title
            }
        }
    }
</script>

<style scoped>

</style>
